import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root",
})
export class StorageHelperService {
  /**
   * Session state (tokens, claims, isLoggedIn) lives in sessionStorage only, so
   * that closing the tab ends the session and the user has to log in again.
   * Do not add localStorage accessors here - localStorage survives tab close.
   */
  constructor() { }

  public getItemFromSession(key: string) {
    if (sessionStorage.getItem(key)) {
      return this.base64ToJson(sessionStorage.getItem(key)!);
    }
  }

  public setItemToSession(key: string, value: any) {
    return sessionStorage.setItem(key, this.jsonToBase64(value));
  }

  public removeItemFromSession(key: string) {
    return sessionStorage.removeItem(key);
  }

  public clearSessionStorage() {
    sessionStorage.clear();
  }

  /** Clears everything except this device's appearance choices (theme and text size), which outlive a login. */
  public clearLocalStorage() {
    const keep = ["fz-theme", "fz-scale"].map(key => [key, localStorage.getItem(key)] as const);
    localStorage.clear();
    keep.forEach(([key, value]) => value !== null && localStorage.setItem(key, value));
  }

  /**
   * Removes session keys written by builds that stored them in localStorage.
   * Targeted rather than a full clear so unrelated preferences survive.
   */
  public clearLegacyLocalSession() {
    ['accessToken', 'refreshToken', 'refreshTokenExpiry', 'isLoggedIn', 'userID', 'allRoles', 'Access', 'sharedData']
      .forEach((key) => localStorage.removeItem(key));
  }

  public clearStorage() {
    this.clearLocalStorage();
    this.clearSessionStorage();
  }

  public jsonToBase64(object: any) {
    const json = JSON.stringify(object);
    //return Buffer.from(json).toString("base64");
    return window.btoa(json);
  }

  public base64ToJson(base64String: string) {
    //const json = Buffer.from(base64String, "base64").toString();
    const json = window.atob(base64String);
    return JSON.parse(json);
  }
}
